import { FailIcon } from 'assets/icons/FailIcon'
import { Badge } from 'components/Badge/Badge'
import { ClockIcon } from 'pages/Accomodation/icons/ClockIcon'
import { SuccessIcon } from 'pages/Accomodation/icons/SuccessIcon'
import styled from 'styled-components'
import { colors, ColorVariant, Flex, Icon } from 'styling/GlobalStyles'
import { BigText, SmallText } from 'styling/TypographyV2'
import {
  CurrentWorkflowStep,
  WorkflowResolutionStatus,
  WorkflowStepStatus,
} from 'types/procurement'
import { convertToDate } from 'utils/helpers'

export const WorkflowProgressItem = ({
  step,
  currentStep,
  lastStep = false,
}: {
  step: CurrentWorkflowStep
  currentStep?: CurrentWorkflowStep
  lastStep?: boolean
}) => {
  const completedByUser = step.completedByUser
    ? step.completedByUser.firstName + ' ' + step.completedByUser.lastName
    : null

  const getColor = () => {
    if (step.status === WorkflowStepStatus.Completed) {
      return step.resolutionStatus === WorkflowResolutionStatus.Approved
        ? colors.green
        : step.resolutionStatus === WorkflowResolutionStatus.Rejected
        ? colors.red
        : currentStep?.id === step.id
        ? colors.orange
        : colors.green
    } else if (step.id === currentStep?.id) {
      return colors.orange
    }
    return 'currentColor'
  }

  const getIcon = () => {
    if (step.status === WorkflowStepStatus.Completed) {
      return step.resolutionStatus === WorkflowResolutionStatus.Approved ? (
        <SuccessIcon />
      ) : step.resolutionStatus === WorkflowResolutionStatus.Rejected ? (
        <FailIcon />
      ) : step.resolutionStatus === WorkflowResolutionStatus.RequestChanges ? (
        <ClockIcon color='currentColor' />
      ) : (
        <SuccessIcon />
      )
    }
    return <ClockIcon color='currentColor' />
  }

  const getBadgeColor = () => {
    if (step.status === WorkflowStepStatus.Completed) {
      return step.resolutionStatus === WorkflowResolutionStatus.Approved
        ? colors.green
        : step.resolutionStatus === WorkflowResolutionStatus.Rejected
        ? colors.red
        : colors.green
    } else if (step.id === currentStep?.id) {
      return colors.orange
    }
    return 'currentColor'
  }

  const getBadgeText = () => {
    if (step.status === WorkflowStepStatus.Completed) {
      return step.resolutionStatus === WorkflowResolutionStatus.Approved
        ? 'Approved'
        : step.resolutionStatus === WorkflowResolutionStatus.Rejected
        ? 'Rejected'
        : step.resolutionStatus === WorkflowResolutionStatus.RequestChanges
        ? 'Request Changes'
        : 'Completed'
    } else if (step.id === currentStep?.id) {
      return 'Current Step'
    }
    return 'Pending'
  }

  return (
    <Grid color={getColor()} lastStep={lastStep}>
      <Flex gap='0' center column>
        <Icon size='1.5rem'>{getIcon()}</Icon>
        {!lastStep && <Line />}
      </Flex>
      <Flex column>
        <Flex gap='0.5rem'>
          <BigText bold color={getColor()} mb='0.25rem'>
            {step.name}
          </BigText>
          <Badge hexColor={getBadgeColor()}>{getBadgeText()}</Badge>
        </Flex>
        {completedByUser && (
          <SmallText semibold colorVariant={ColorVariant.SECONDARY} mb='0.25rem'>
            {completedByUser} • {convertToDate(step.completedAt)}
          </SmallText>
        )}

        {step.comment && (
          <SmallText colorVariant={ColorVariant.SECONDARY} mb='0.25rem'>
            &rdquo;{step.comment}&rdquo;
          </SmallText>
        )}
      </Flex>
    </Grid>
  )
}

const Grid = styled.div<{ color?: string; lastStep?: boolean }>`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.5rem;
  color: ${(props) => props.color};
  position: relative;
  padding-bottom: ${({ lastStep }) => (lastStep ? '0' : '0.5rem')};
`
const Line = styled.div`
  width: 1px;

  background-color: currentColor;
  position: absolute;
  top: 24px;
  bottom: 0;
`
